import { createContext, useContext, RefObject } from "react";

export const PortalContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

export const usePortalContainer = () => {
  const context = useContext(PortalContext);

  if (!context) {
    throw new Error("usePortalContainer must be used within a PortalProvider");
  }
  return context;
};
